import { jsxs, jsx } from 'react/jsx-runtime';
import { PENDING_OPERATION, COMPLETED_OPERATION, StatoOperazione } from './SnackbarUtils.js';
import Spinner from '../Spinner/Spinner.js';
import SuccessoIcon from '../Icons/SuccessoIcon.js';
import ErroreIcon from '../Icons/ErroreIcon.js';

const anyAsycRunning = (operazioniMassive) => operazioniMassive.filter((x) => x.stato === StatoOperazione.PENDING).length > 0;
const getMessage = (operazioniMassive) => {
    if (anyAsycRunning(operazioniMassive)) {
        return PENDING_OPERATION;
    }
    return COMPLETED_OPERATION;
};
const getIcon = (operazioniMassive) => {
    if (anyAsycRunning(operazioniMassive))
        return jsx(Spinner, { small: true });
    const ultimaOperazione = operazioniMassive
        .filter((x) => x.finishedTimestamp)
        .sort((a, b) => (new Date(a.timeStamp)).getTime() - (new Date(b.timeStamp)).getTime())[0];
    if (ultimaOperazione) {
        if (ultimaOperazione.errori.length > 0) {
            return jsx(ErroreIcon, { className: "icon snackbar__iconWarning" });
        }
        return jsx(SuccessoIcon, { className: "icon snackbar__iconSuccess" });
    }
    return null;
};
const HeaderMassiva = ({ operazioniMassive }) => (jsxs("div", { className: "snackbar__titoloHeader", children: [jsx("div", { className: "snackbar__iconWrapper", children: getIcon(operazioniMassive) }), jsx("p", { className: "snackbar__title", children: getMessage(operazioniMassive) })] }));
HeaderMassiva.defaultProps = {
    operazioniMassive: [],
};

export { HeaderMassiva as default };
